import React from "react";
import styles from "./Grid.module.sass";
const Grid = props => {
  const {
    data,
    items = [],
    cards = [],
    numOfCols = 3,
    columnsTemplate = [],
    modifiers = [],
    aspect = []
  } = props;
  if (Array.isArray(data) && data.length <= 1 && data[0]["summary"] && data[0]["summary"].length === 0) {
    return null;
  }
  let columns = [];
  const numberOfCols = columnsTemplate && columnsTemplate.length ? columnsTemplate.reduce((acc, colSpan) => acc += parseInt(colSpan, 0), 0) : numOfCols;
  if (columnsTemplate && columnsTemplate.length) {
    columnsTemplate.forEach((colSpan, i) => {
      const Card = cards[i % cards.length];
      const width = Math.floor(100 / numberOfCols * colSpan);
      const [w, h] = aspect[i] ? aspect[i].split(/x/gi) : [];
      const paddingTop = w && h ? `${Math.round(h / w * 100)}%` : null;
      if (i > 0 && modifiers.includes("--grid-border-inline")) {
        columns.push( /*#__PURE__*/React.createElement("span", {
          key: `${i}s`,
          className: styles["inline-border"]
        }));
      }
      columns.push( /*#__PURE__*/React.createElement("div", {
        key: i,
        className: `${styles["cardholder"]} grid-cardholder-exclude`,
        style: {
          maxWidth: `${width}%`
        }
      }, /*#__PURE__*/React.createElement(React.Fragment, null, paddingTop && /*#__PURE__*/React.createElement("div", {
        className: styles["aspect-ratio-controller"],
        style: {
          paddingTop
        }
      }), Card && /*#__PURE__*/React.createElement(Card, items[i] || {}))));
    });
  }
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"]} ${modifiersClasses} ${numberOfCols > 3 ? styles["small"] : ""}`,
    id: "grid-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles["grid"]} ${styles[`grid-size-${numberOfCols}`] || ""}`
  }, columns));
};
export default Grid;